import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { untypedIsEnabled } from '@ip-only/client-features';

@Injectable({
  providedIn: 'root',
})
export class FeatureIsActiveGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const featureName: string = route.data.featureName;
    if (untypedIsEnabled(featureName)) {
      return true;
    } else {
      this.router.navigate(['hoppsan']);
      return false;
    }
  }
}
